module.exports = __webpack_public_path__ + "media/images/twitter-297bd35d17e29ce5943d1a89146bcc39.svg";